import React from 'react';
import { Neo, NeoGrid, Views } from '@singularsystems/neo-react';
import InvestorReferralTypeVM from './InvestorReferralTypeVM';
import { observer } from 'mobx-react';
import * as CatalogueRoles from "../../../Models/Security/CatalogueRoles"
import { Misc, Validation } from '@singularsystems/neo-core';
import BankCatalogueEntry from '../GenericComponents/BankCatalogueEntry';
import { Catalogue } from '@singularsystems/neo-react-services';
import BankDetails from "../../Components/BankDetails";
import BankDetail from "../../../Models/ValueObjects/BankDetail";

@observer
export default class InvestorReferralTypeView extends Views.ViewBase<InvestorReferralTypeVM> {

    constructor(props: unknown) {
        super("Investor Referral Type", InvestorReferralTypeVM, props);
    }

    public render() {
        const canEdit = this.viewModel.authorisationService.hasRole(CatalogueRoles.InvestorReferralTypes.Edit);

        return (
            <div className="mt-4 mb-4">
                <Neo.Card title="Investor Referral Types">

                    {!this.viewModel.editingInvestorReferralType &&
                        <div>
                            <div className="d-flex justify-content-between mb-4">
                                <Neo.Button icon="arrow-left" variant="light" onClick={() => history.back()}>Back</Neo.Button>
                            </div>
                            <NeoGrid.Grid items={this.viewModel.investorReferralTypeList} addButton={{ onClick: () => this.viewModel.newInvestorReferralType() }}>
                                {(item, meta) => (
                                    <NeoGrid.Row>
                                        <NeoGrid.Column display={meta.investorReferralTypeName} />
                                        <NeoGrid.Column display={meta.minimumLimit} />
                                        <NeoGrid.ButtonColumn editButton={{ onClick: () => this.viewModel.editInvestorReferralTypes(item) }}
                                            deleteButton={{ onClick: () => this.viewModel.deleteInvestorReferralType(item), disabled: !canEdit }} />
                                    </NeoGrid.Row>
                                )}
                            </NeoGrid.Grid>
                        </div>
                    }

                    {this.viewModel.editingInvestorReferralType &&
                        <Neo.Form
                            allReadOnly={!this.viewModel.authorisationService.hasRole(CatalogueRoles.InvestorReferralTypes.Edit)}
                            model={this.viewModel.editingInvestorReferralType}
                            showSummaryModal onSubmit={() => this.viewModel.saveInvestorTypes()}
                            validationDisplayMode={Validation.DisplayMode.Always}>
                            {(item, meta) => (
                                <div>
                                    <div className="d-flex justify-content-between mb-4">
                                        <Neo.Button icon="arrow-left" variant="light" onClick={() => this.viewModel.editingInvestorReferralType = null}>Back</Neo.Button>
                                        <Neo.Button
                                            isSubmit icon="save"
                                            disabled={!this.viewModel.editingInvestorReferralType!.readyToSave}
                                            pulse={this.viewModel.editingInvestorReferralType!.readyToSave}>Save</Neo.Button>
                                    </div>

                                    <Neo.GridLayout>
                                        <div>
                                            <Neo.FormGroupInline bind={meta.investorReferralTypeName} />
                                            <Neo.FormGroupInline
                                                bind={meta.minimumLimit}
                                                numProps={{ formatString: "#,##0.##" }} />
                                            <Neo.FormGroupInline bind={meta.physicalAddress} input={{ rows: 3 }} />
                                            <Neo.FormGroupInline bind={meta.postalAddress} input={{ rows: 3 }} />
                                            <Neo.FormGroupInline bind={meta.phoneNos} />
                                            <Neo.FormGroupInline bind={meta.mist} />
                                            <Neo.FormGroupInline bind={meta.cisNumber} />
                                            <Neo.FormGroupInline bind={meta.agreementFooter} input={{ rows: 3 }}/>
                                            <Neo.FormGroupInline bind={meta.requiresExternalAccountNo}
                                                footerText="Indicates that investors of this type require an external account no." />
                                        </div>
                                        <div>
                                            {item.bankDetails &&
                                                <div>
                                                    <BankDetails bankDetail={item.bankDetails} />
                                                    <Neo.Button size="sm" variant="danger" icon="trash" onClick={() => item.bankDetails = null}>Clear Bank Details</Neo.Button>
                                                </div>}
                                            {!item.bankDetails &&
                                                <Neo.Button size="sm" icon="plus" onClick={() => item.bankDetails = new BankDetail()}>Add Bank Details</Neo.Button>}
                                        </div>
                                    </Neo.GridLayout>
                                </div>
                            )}

                        </Neo.Form>
                    }
                </Neo.Card>
            </div>
        );
    }
}